import { buffer2hexArr, isAlphaNumeric } from "../../utils/utils";
import FrameProcessingService from "../device/frameProcessingService"
import log from "../logger/logger";
import * as scp from "../../consts/scpConsts";
import { mapResponseFrame, mapSerialNumberFramePayload } from "./scpUtils";
import ConnectedExponentialBackOff from "../ble/connectedExponentialBackOff";

const READING_TIMEOUT_BLE = 3000;

const identifyDevice = (deviceId) => {
    console.debug("Start device identification");
    return getInfo(deviceId);
}

const getInfo = async (deviceId) => {
    let serialNumber = await runWithBackOff(deviceId, getSerialNumberInt);
    let firmware = await runWithBackOff(deviceId, getFirmwareInt);
    let codentify = await runWithBackOff(deviceId, getCodentifyInt);

    return {
        serialNumber,
        firmware,
        codentify
    }
}

const runWithBackOff = async (deviceId, action) => {
    const backOff = new ConnectedExponentialBackOff(deviceId);

    const result = await new Promise((resolve, reject) => {
        backOff.run(
            3,
            1000,
            async () => await action(deviceId),
            resolve,
            reject
        );
    });

    return result;
}

const getCodentifyInt = (deviceId) => {
    return new Promise((res, rej) => {
        const frameProcessingService = new FrameProcessingService(deviceId);
        frameProcessingService.addFrameToQueue({
            frame: scp.FRAME_CHARGER_CODENTIFY,
            timeout: READING_TIMEOUT_BLE,
            onResponse: (frame) => {
                const frameConverted = mapResponseFrame(buffer2hexArr(frame));
                if (frameConverted.isError) {
                    rej(new Error("Codentify read error"))
                }

                let codentify = String.fromCharCode.apply(null, frameConverted.payload);
                if (isAlphaNumeric(codentify)) {
                    codentify = codentify.toUpperCase();
                }

                res(codentify);
            },
            onError: (error) => {
                log.error("Error occurred during the device identification", error);
                rej();
            }
        })
    });
}

const getFirmwareInt = (deviceId) => {
    return new Promise((res, rej) => {
        const frameProcessingService = new FrameProcessingService(deviceId);
        frameProcessingService.addFrameToQueue({
            frame: scp.FRAME_CHARGER_FIRMWARE,
            timeout: READING_TIMEOUT_BLE,
            onResponse: (frame) => {
                const frameConverted = mapResponseFrame(buffer2hexArr(frame));
                if (frameConverted.isError) {
                    rej(new Error("Firmware read error"))
                }

                const major = frameConverted.payload[2];
                const minor = frameConverted.payload[3];
                const buildNumberStr = frameConverted.payload.slice(5, 6).reverse().map((x) => x.toString(16).padStart(2, '0')).join('');
                const buildNumber = parseInt(buildNumberStr, 16);
                res(`${major}.${minor}.${buildNumber}`);
            },
            onError: (error) => {
                log.error("Error occurred during the device identification", error);
                rej();
            }
        })
    });
}

const getSerialNumberInt = (deviceId) => {
    return new Promise((res, rej) => {
        const frameProcessingService = new FrameProcessingService(deviceId);
        frameProcessingService.addFrameToQueue({
            frame: scp.FRAME_CHARGER_SERIAL,
            timeout: READING_TIMEOUT_BLE,
            onResponse: (frame) => {
                const frameConverted = mapResponseFrame(buffer2hexArr(frame));
                if (frameConverted.isError) {
                    rej(new Error("Serial number read error"))
                }

                const deviceSerial = mapSerialNumberFramePayload(frameConverted.payload);

                const upperCaseSerialNumber = deviceSerial?.dusn.toUpperCase();

                const serial = '0' + upperCaseSerialNumber.charAt(1).toLowerCase() + upperCaseSerialNumber.slice(2);

                res(serial);
            },
            onError: (error) => {
                log.error("Error occurred during the device identification", error);
                rej(error)
            }
        })
    });
}

const scpService = {
    identifyDevice,
    mapResponseFrame,
    runWithBackOff
}

export default scpService;